const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjMzMyA1MTIgMzQxLjMzMyI+CjxyZWN0IHk9Ijg1LjMzMSIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIzNDEuMzM3Ii8+CjxyZWN0IHk9Ijg1LjMzMSIgZmlsbD0iIzAwNTJCNCIgd2lkdGg9IjE3MC42NjMiIGhlaWdodD0iMzQxLjMzNyIvPgo8cmVjdCB4PSIzNDEuMzM3IiB5PSI4NS4zMzEiIGZpbGw9IiNEODAwMjciIHdpZHRoPSIxNzAuNjYzIiBoZWlnaHQ9IjM0MS4zMzciLz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=FR-5d4e14ee.mjs.map
